import styled from 'styled-components/macro';

export const CropContainer = styled.div`
  width: 300px;
  position: relative;
  height: 300px;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 25px;

  @media screen and (max-width: 389px) {
    width: 250px;
    height: 250px;
  }

  @media screen and (max-width: 336px) {
    width: 200px;
    height: 200px;
  }
  
`;

export const FileInput = styled.p`
  position: relative;

  input[type='file'],
  input[type='file']::-webkit-file-upload-button {
    cursor: pointer;
  }

  label {
    background: ${({ color }) => color};
    color: white;
    transition: all 0.25s ease-in-out;
    font-size: 0.9em;
    padding: 8px 9px;
    box-shadow: 0 0 4px 4px rgb(0 0 0 / 15%);
    border-radius: 10px;
    margin-right: 5px;
    cursor: pointer;
  }
  input {
    position: absolute;
    display: inline-block;
    left: 0;
    top: 0;
    opacity: 0.01;
  }
  input:hover + label,
  input:focus + label {
    color: ${({ color_L2 }) => color_L2};
    box-shadow: 0 0 4px 4px rgb(0 0 0 / 18%);
  }
`;
